export default __webpack_public_path__ + "static/uri-090573d5c630703dd76feb6956eb275b.png";